// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"EventsList_pageHeader__2OVVj"};